import { LanguageType } from '@/custom-types'
import { useUserLanguage } from '@/customHooks'
import { UnityStatusOption } from '@/graphql/generated'
type UnityStatusOptionPillProps = {
  option: UnityStatusOption
}

type OptionConfig = {
  text: string
  className: string
}

const STYLES = {
  success: "text-[#4a9462] bg-[#d2f3dc]",
  error: "text-[#ff7878] bg-[#ffd7d7]",
  neutral: "text-[#808080] bg-[#ECECEC]",
} as const

const OPTION_MAPPING: Record<LanguageType, Record<UnityStatusOption, OptionConfig>> = {
  en: {
    [UnityStatusOption.Vacant]: { text: "Vacant", className: STYLES.success },
    [UnityStatusOption.Occupied]: { text: "Occupied", className: STYLES.error },
    [UnityStatusOption.NotAvailable]: { text: "Not Available", className: STYLES.neutral },
  },
  es: {
    [UnityStatusOption.Vacant]: { text: "Vacante", className: STYLES.success },
    [UnityStatusOption.Occupied]: { text: "Ocupada", className: STYLES.error },
    [UnityStatusOption.NotAvailable]: { text: "No Disponible", className: STYLES.neutral },
  },
}

export const UnityStatusOptionPill = ({ option }: UnityStatusOptionPillProps) => {
  const language = useUserLanguage()

  const config =
    OPTION_MAPPING[language]?.[option] ??
    { text: option, className: STYLES.neutral }

  return (
    <div
      className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-xs font-semibold ${config.className}`}
    >
      {config.text}
    </div>
  )
}
